import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { BlankIcon } from "./BlankMarker";

export const BlankLegend: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div
      className="flex items-center gap-2 px-2 pt-3 border-t border-border-border1"
      data-test="proposal-blank-legend"
    >
      <BlankIcon />
      <Text variant="bodySecondary">
        {t("contracts.proposals.editor.needsInput")}
      </Text>
    </div>
  );
};
